import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { ButtonHTMLAttributes, forwardRef } from "react";
import classes from "./button.module.css";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "primary" | "secondary";
  size?: "small" | "medium" | "large" | "icon";
  asChild?: boolean;
  fullWidth?: boolean;
  alignment?: "start" | "center" | "end" | "spaceBetween";
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      asChild,
      className = "",
      fullWidth = false,
      size,
      variant = "default",
      alignment = "center",
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        disabled={disabled}
        aria-disabled={disabled}
        className={clsx(
          classes.root,
          size && classes[size],
          classes[variant],
          fullWidth && classes.fullWidth,
          classes[alignment],
          className,
        )}
        {...props}
      />
    );
  },
);

Button.displayName = "Button";
